import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useReanalyzeQuickImports } from '../../../hooks/api/backfills/useReanalyzeQuickImports';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger re-analysis of quick-imported projects.
 */
export const ReanalyzeQuickImportCard: VoidFunctionComponent = () => {
  const { mutate: reanalyzeQuickImports, isPending } = useReanalyzeQuickImports();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Reanalyze all quick-imported projects',
      body: (
        <div>
          Are you sure you want to reanalyze all quick-imported projects?
        </div>
      ),
      onConfirm: async () => {
        reanalyzeQuickImports();
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Re-Analyze Quick Import</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue re-analysis of all quick-imported projects for this
          organization, regardless of whether they used V1 or V2 of quick-import
          originally.
        </Text.Paragraph>
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Re-Analyze
        </Button>
      </Card.Content>
    </Card>
  );
};

export default ReanalyzeQuickImportCard;
